import Currency from "../../Currency";
import MoneyExchangeRateRange from "./MoneyExchangeRateRange";

class MoneyExchangeRate {
    public id: string;
    public agencyId: string;
    public currency: Currency;
    public exchangeRateRanges: MoneyExchangeRateRange[];

    constructor(id: string, agencyId: string, currency: Currency, exchangeRateRanges: MoneyExchangeRateRange[]) {
        this.id = id;
        this.agencyId = agencyId;
        this.currency = currency;
        this.exchangeRateRanges = exchangeRateRanges;
    }
}

export default MoneyExchangeRate;